import React from "react";
import { Link } from "react-router-dom";

/**
 * Tarjeta-botón de Bloc (alargada, responsive, con sombra y animación).
 * Props:
 *  - to: string (ruta)
 *  - title: string (texto ya traducido)
 */
export default function BlockCard({ to, title }) {
  return (
    <Link
      to={to}
      className={[
        "group relative block h-full",
        "rounded-2xl border bg-white",
        "shadow-sm hover:shadow-xl",
        "transition duration-200 ease-out",
        "hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500",
      ].join(" ")}
      title={title}
    >
      <div className="p-6 md:p-7 min-h-[110px] flex items-center">
        <h3
          className={[
            "text-base sm:text-lg md:text-xl font-semibold leading-snug",
            "text-gray-900",
            "break-words whitespace-normal",
          ].join(" ")}
        >
          {title}
        </h3>
        <div
          className={[
            "ml-auto inline-flex items-center gap-2 text-emerald-700 text-sm font-medium",
            "opacity-0 group-hover:opacity-100 translate-x-0.5",
            "transition-all duration-200",
          ].join(" ")}
          aria-hidden="true"
        >
          <span>→</span>
        </div>
      </div>

      {/* Glow sutil */}
      <div className="pointer-events-none absolute inset-0 rounded-2xl ring-1 ring-black/5 group-hover:ring-emerald-300/40 transition" />
    </Link>
  );
}
